import {useEffect} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {SHOWED_GUEST_GROUP_MODAL} from 'utils/constants';
import {useSummary} from 'context/summary';
import {useModalOncePerSession} from 'hooks';
import {useModalControls} from 'hooks/common';
import {useReservationSettingsModal} from 'components/ReservationSettingsModal';
import CheckInCompleteModal from 'components/CheckInCompleteModal';
import {LogoutModalSheet} from 'pages/Auth';

function HomeViewModals() {
  const {reservationId} = useSummary();
  const {state} = useLocation();
  const navigate = useNavigate();

  const isLoggingOut = state?.isLoggingOut;

  const {shouldOpenModal: openWhoIsComingModalPerSession} = useModalOncePerSession({
    id: reservationId,
    storageKey: SHOWED_GUEST_GROUP_MODAL,
  });

  const {Modal: WhoIsComingModal} = useReservationSettingsModal({
    openModalPerSession: openWhoIsComingModalPerSession,
    showFirstTime: true,
  });

  const {
    isOpen: isLogoutModalOpen,
    openModal: openLogoutModal,
    closeModal: closeLogoutModal,
  } = useModalControls();

  useEffect(
    function handleOpenLogoutModal() {
      if (isLoggingOut) {
        openLogoutModal();
        navigate(location.pathname, {replace: true, state: {}});
      }
    },
    [openLogoutModal, isLoggingOut, navigate],
  );

  return (
    <>
      {WhoIsComingModal}
      <CheckInCompleteModal />
      {/* <CheckOutCompleteModal /> */} {/* TODO: uncomment v2 */}
      <LogoutModalSheet
        isOpenModalSheet={isLogoutModalOpen}
        handleCloseModal={closeLogoutModal}
      />
    </>
  );
}

export {HomeViewModals};
